module.exports = __webpack_public_path__ + "img/p_23.29d35a51.png";